import { BriefingInputController } from './briefing-input.controller'

function briefingInput () {
  return {
    restrict: 'E',
    scope: {
      field: '<',
      readOnly: '<',
      onChange: '&',
      onReady: '&'
    },
    templateUrl: '/workflow/components/briefing-input/briefing-input.html?$$REVISION$$',
    controller: BriefingInputController
  }
}

export { briefingInput }
